import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import backBtn from "../../assets/images/backBtn.svg";
import { EducationalEnrollment } from "./EducationalComponents";
import EducationalContentHeader from "./EducationalContentHeader";
import { EducationalContentContinueButton, EducationalContentTertiaryButton } from "./EducationalContentContinueButton";
import { getEnrollmentHandler, getEnrollmentSliceAction } from "../../redux/action/guestUserAction/getEnrollment";
import { useDispatch, useSelector } from "react-redux";
import { acceptEnrollmentHandler, acceptEnrollmentSliceAction } from "../../redux/action/guestUserAction/acceptEnrollment";
import { guestEnrollmentBackPath } from "../../common/guestEnrollmentFlow";
import { STATUS_CODE } from "../../common";
import { useCommonMessage } from "../../common/CommonMessage";
import Loader from "../Loder/loader";
import NoDataAvailableState from "./NoDataAvailableState";

const EducationalContentEnrollment = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [enrollmentDecision, setEnrollmentDecision] = useState("PENDING");
  const [showPaycheckUpdatedModal, setShowPaycheckUpdatedModal] = useState(false);
  const dispatch = useDispatch();
  const getEnrollmentSelector = useSelector((state) => state?.getEnrollment);
  const acceptEnrollmentSelector = useSelector((state) => state?.acceptEnrollment);
  const messageApi = useCommonMessage();
  const isInitialLoading = getEnrollmentSelector?.isLoading;
  const isAcceptLoading = acceptEnrollmentSelector?.isLoading;
  const isAnyLoading = isInitialLoading || isAcceptLoading;
  const enrollmentData = getEnrollmentSelector?.data;
  const isEnrollmentLoaded =
    !isInitialLoading && enrollmentData && enrollmentData?.statusCode === STATUS_CODE.OK;
  const showNoDataState =
    !isInitialLoading && enrollmentData && enrollmentData?.statusCode !== STATUS_CODE.OK;
  const handleBack = () => {
    navigate(guestEnrollmentBackPath("enrollment"));
  };

  const handleYesClick = () => {
    setEnrollmentDecision("YES");
    dispatch(getEnrollmentSliceAction.getEnrollmentSliceReset());
    dispatch(acceptEnrollmentHandler({
      memberAction: "YES",
    }));
  };

  const handleNoClick = () => {
    setEnrollmentDecision("NO");
    navigate("/guest-user/enrollment-decline-confirmation", { state: { enrollmentDecision: "NO" } });
    dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceReset());
  };

  const handlePaycheckUpdatedOk = () => {
    const payCheckStatus = getEnrollmentSelector?.data?.data?.payCheckStatus;
    setShowPaycheckUpdatedModal(false);
    navigate("/guest-user/paycheck", {
      state: {
        payCheckStatus: payCheckStatus || "PAYCHECK_ILLUSTRATION_VIEWED",
      },
    });
    dispatch(getEnrollmentSliceAction.getEnrollmentSliceReset());
    dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceReset());
  };

  useEffect(() => {
    dispatch(getEnrollmentHandler());
  }, [dispatch]);

  useEffect(() => {
    if (acceptEnrollmentSelector?.data?.statusCode === STATUS_CODE.OK) {
      if (acceptEnrollmentSelector?.data?.data?.payCheckStatus) {
        setShowPaycheckUpdatedModal(true);
      }
      else {
        if (enrollmentDecision !== null) {
          if (enrollmentDecision === "YES") {
            navigate("/guest-user/esign", {
              state: { enrollmentDecision: "YES" },
            }
            );
            dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceReset());
          } else {
            navigate("/guest-user/thank-you", {
              state: { enrollmentDecision: "NO" },
            });
            dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceReset());
          }
        }
      }
    }
    else if (acceptEnrollmentSelector?.data?.error === true) {
      messageApi.error(acceptEnrollmentSelector?.data?.message);
      dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceReset());
    }
  }, [acceptEnrollmentSelector, enrollmentDecision, navigate, dispatch, messageApi]);

  useEffect(() => {
    if (showNoDataState && enrollmentData?.message) {
      messageApi.error(enrollmentData?.message);
    }
  }, [showNoDataState, enrollmentData, messageApi]);

  // useEffect(() => {
  //   if (getEnrollmentSelector?.data?.data?.enrollmentActionStatus) {
  //     setEnrollmentDecision(getEnrollmentSelector?.data?.data?.enrollmentActionStatus);
  //   }
  // }, [getEnrollmentSelector?.data?.data?.enrollmentActionStatus]);

  useEffect(() => {
    const payCheckStatus = getEnrollmentSelector?.data?.data?.payCheckStatus;
    if (payCheckStatus) {
      setShowPaycheckUpdatedModal(true);
    }
  }, [getEnrollmentSelector?.data?.data?.payCheckStatus]);
  console.log(getEnrollmentSelector, "getEnrollmentSelector");

  return (
    <EducationalContentHeader
      backBtnSrc={backBtn}
      backBtnMobileSrc={backBtnMobile}
      onBack={handleBack}
      title={t("Enrollment Action")}
      hideNavigation={false}
      stepText={`${t("Step")} 3 ${t("of")} 4`}
      progress="75%"
    >
      <div className="stepperview mb-60">
        {isAnyLoading && <Loader loaderTransform="loaderTransform" />}
        {!isAnyLoading && showNoDataState && (
          <NoDataAvailableState subtitle="There is no educational material found" />
        )}
        {!isAnyLoading && isEnrollmentLoaded && (
          <EducationalEnrollment
          // selected={enrollmentDecision}
          // setSelected={(value) => {
          //   setEnrollmentDecision(value);
          //   setSelectionError("");
          // }}
          />
        )}
      </div>
      <div>
        <EducationalContentContinueButton
          hideNavigation={false}
          onContinue={handleYesClick}
          buttonLabel={t("Yes, I would like to keep these benefits")}
          disabled={!isEnrollmentLoaded || isAnyLoading}
        />
        {isEnrollmentLoaded && getEnrollmentSelector?.data?.data?.enrollmentActionStatus !== "NO" && (
          <EducationalContentTertiaryButton
            hideNavigation={false}
            onContinue={handleNoClick}
            buttonLabel={t("No, I do not want to keep these benefits")}
            disabled={isAnyLoading}
          />
        )}
      </div>


      <Modal
        className="paycheckConfirmationModal"
        centered
        open={showPaycheckUpdatedModal}
        // onCancel={() => {}}
        footer={null}
        closeIcon={null}
        maskClosable={false}
        keyboard={false}
      >
        <div className="tgb fs-20 lh-25 mb-40 text-center">
          {t(
            "Your paycheck has been updated. Tap Okay to view your paycheck illustration."
          )}
        </div>
        <div className="text-center">
          <button
            type="button"
            className="saveBtn cursor-pointer "
            onClick={handlePaycheckUpdatedOk}
          >
            {t("Okay")}
          </button>
        </div>
      </Modal>
    </EducationalContentHeader>
  );
};

export default EducationalContentEnrollment;
